import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { format } from "date-fns";

import { buildEndorsementActions } from "./buildEndorsementActions";
import { EndorsementMeatballMenu } from "./EndorsementMeatballMenu";
import { EndorsementStatusPill } from "./EndorsementStatusPill";
import { EndorsementCardProps } from "./types";

export type { EndorsementCardProps };

export function EndorsementCard({
  endorsementId,
  effectiveDate,
  status,
  reason,
  isSocotraNative = false,
  isExpiredPolicy = false,
  isReadOnly = false,
  onUpdateEndorsement,
  onIssueEndorsement,
  onReviewIssue,
  onUwReview,
  onDiscard,
}: EndorsementCardProps) {
  const actions = isReadOnly
    ? []
    : buildEndorsementActions(status, isSocotraNative, isExpiredPolicy, {
        onUpdateEndorsement,
        onIssueEndorsement,
        onReviewIssue,
        onUwReview,
        onDiscard,
      });

  return (
    <Box
      sx={{
        px: 2,
        py: 2.5,
        borderLeft: 3,
        borderLeftColor: "transparent",
        transition: "border-left-color 0.15s ease",
        "&:hover": {
          borderLeftColor: "primary.main",
        },
      }}>
      <Grid container alignItems="center">
        <Grid item xs>
          <Stack spacing={0.5}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography
                variant="subtitle1"
                fontWeight={500}
                fontSize={"1.25rem"}
                color="text.primary">
                Endorsement {endorsementId}
              </Typography>
              <EndorsementStatusPill displayStatus={status} />
            </Stack>

            <Typography
              variant="caption"
              color="text.secondary"
              fontSize={"1rem"}>
              Effective{" "}
              {format(
                new Date(
                  effectiveDate.indexOf(":") === -1
                    ? `${effectiveDate} 00:00:00`
                    : effectiveDate
                ),
                "MM/dd/yyyy"
              )}
            </Typography>

            {reason && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  fontSize: "1.0rem",
                }}>
                {reason.length > 80 ? `${reason.slice(0, 80)}…` : reason}
              </Typography>
            )}
          </Stack>
        </Grid>

        {actions.length > 0 && (
          <Grid item xs="auto">
            <EndorsementMeatballMenu actions={actions} />
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
